/**
 * Reads the Desired Initial Draft Date validation message whether Yup reported
 * it at the object path (draftDate: null → flat { message }) or nested
 * (draftDate: { startDate: null } → { startDate: { message } }).
 *
 * ExistingProvider used to dereference errors.draftDate.startDate.message
 * unconditionally; the flat shape threw mid-render and blanked the page (AB#14582).
 */
export function getDraftDateErrorMessage(draftDateError) {
  if (!draftDateError) {
    return undefined;
  }

  if (draftDateError.message) {
    return draftDateError.message;
  }

  return draftDateError.startDate?.message;
}
